import {constants} from "../../constants";

export const toggleDueBookModal = () => {
    return { type: constants.PENALTIY_MODAL_ACTION };
};
